import { render, staticRenderFns } from "./ExcelViewer.vue?vue&type=template&id=2f9e0045&scoped=true"
import script from "./ExcelViewer.vue?vue&type=script&lang=js"
export * from "./ExcelViewer.vue?vue&type=script&lang=js"
import style0 from "./ExcelViewer.vue?vue&type=style&index=0&id=2f9e0045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9b90bd239842d9ab132761d251f24808/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e0045",
  null
  
)

export default component.exports